import { TaskTracker } from "../stores/budgetReview/budgetReview.interface";
import { convertUSDToNumber } from "../utils/formatChecks";
import { taskNames } from "../stores/tasks/Tasks.action";
import { budgetReviewStatusEnum } from "../ilp/list-view/BudgetTaskManagement";
import { getTimeFromDate } from "../utils/utils";

export function convertNumberToUSD(input: number | string): string {
  const number = typeof input === "number" ? input : parseFloat(input);
  if (isNaN(number)) {
    return "";
  }
  const fixedNumber = number.toFixed(2);
  const parts = fixedNumber.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `$${parts.join(".")}`;
}

export const getDate = (date: string, format?: string) => {
  const formattedDate = getTimeFromDate(date, format || "MMM DD, YYYY, HH:mm");
  return formattedDate;
};

export const addEmptyLineItems = (
  row: any,
  fieldsData: any[],
  withNullAsId?: any,
  unitVal?: string | number
) => {
  const newFields = [];

  for (let i = 0; i < row.val; i++) {
    const newField = {
      id: withNullAsId ? null : `tempId_${Math.random()}`,
      unit: unitVal || 1,
      item: "",
      description: "",
      financedBudget: withNullAsId ? 0 : "$0.00",
      budget: withNullAsId ? 0 : "$0.00",
      StandardizedItem: "",
      standardizedItemId: null
    };

    newFields.push(newField);
  }

  return [...fieldsData, ...newFields];
};

// Prefer BudgetDocs.filter directly in new call sites. Re-exported here so
// existing imports (and tests) keep working without the old "latest-first"
// filter that dropped SCOW/REBD docs when a newer non-budget doc shared the
// same PROPERTY asset.
export { filterObjectsByTag } from "./BudgetDocs.filter";

export function sortArrayByUpdatedOn(arr: TaskTracker[]): TaskTracker[] {
  if (!arr?.length) return [];
  return arr.sort((a, b) => {
    const dateA = new Date(a.updatedOn);
    const dateB = new Date(b.updatedOn);
    return dateB.getTime() - dateA.getTime();
  });
}

export function checkPropertyMapped(obj: any): boolean {
  // Check if the object has the "propertyId" field
  if (
    obj.staticData?.documentData &&
    Object.prototype.hasOwnProperty.call(
      obj.staticData.documentData,
      "propertyId"
    )
  ) {
    // Check if the value of "propertyId" is not null and not undefined
    return obj.staticData?.documentData?.propertyId !== null;
  }
  return false;
}

export const transformToReduxList = (arr: any[]) =>
  arr.map((item: any) => ({
    budgetLineItemOrder: item.budgetLineItemOrder,
    budgetLineItemId: item.budgetLineItemId,
    item: item.item,
    description: item.description,
    // budget: item.budget?.replace(/[\$,]/g, "") || item.budget, // Remove "$" and commas to keep it numeric
    budget: `${convertUSDToNumber(item.budget)}`,
    financedBudget: `${convertUSDToNumber(item.financedBudget)}`,
    // item.financedBudget?.replace(/[\$,]/g, "") || item.financedBudget, // Remove "$" and commas to keep it numeric
    commentThreadId: item.commentThreadId,
    unit: item.unit,
    comments: null // Set comments to null
  }));

export function isBudgetThereAndNotStarted(
  tasks: any[],
  isDSCR: boolean
): boolean {
  if (isDSCR) return false;

  const assignedTasks = tasks?.[0]?.assignedTasks || [];

  return assignedTasks.some(
    (task: any) =>
      task.taskName === taskNames.BUDGET_REVIEW &&
      [
        budgetReviewStatusEnum.LoanSubmitted,
        budgetReviewStatusEnum.BudgetMissing
      ].includes(task.taskStatus)
  );
}
